(function () {
  'use strict';

  if (window.AxiomProductPopupBound) return;
  window.AxiomProductPopupBound = true;

  function api() {
    return window.Axiom || {};
  }

  function rootFrom(target) {
    return target && target.closest ? target.closest('[data-product-popup]') : null;
  }

  function parts(root) {
    if (!root) return null;
    return {
      root: root,
      trigger: root._popupTrigger || root.querySelector('[data-product-popup-open]'),
      overlay: document.getElementById('site-overlay'),
      panel: root._popupPanel || root.querySelector('.product-popup__panel')
    };
  }

  function rememberHome(panel, root) {
    if (!panel) return;
    root._popupPanel = panel;
    if (panel._popupHome) return;
    panel._popupHome = {
      parent: panel.parentNode,
      next: panel.nextSibling,
      root: root
    };
  }

  function movePanelToBody(panel) {
    if (!panel || panel.parentNode === document.body) return;
    document.body.appendChild(panel);
  }

  function restorePanel(panel) {
    var home = panel && panel._popupHome;
    if (!home || !home.parent || !home.parent.isConnected) return;
    if (home.next && home.next.parentNode === home.parent) {
      home.parent.insertBefore(panel, home.next);
    } else {
      home.parent.appendChild(panel);
    }
  }

  function isOpen(panel) {
    return Boolean(panel && panel.classList.contains('is-open'));
  }

  function setExpanded(trigger, expanded) {
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function openPopup(root) {
    var refs = parts(root);
    if (!refs || !refs.panel) return;
    var overlay = refs.overlay;
    rememberHome(refs.panel, root);
    movePanelToBody(refs.panel);
    refs.panel.hidden = false;
    void refs.panel.offsetWidth; // commit display before the open transition starts
    if (refs.panel.getAttribute('inert') !== null) refs.panel.removeAttribute('inert');
    if (overlay) overlay.classList.add('overlay--product-popup-active');

    var theme = api();
    if (root.dataset.productPopupStyle === 'drawer' && typeof theme.openDrawer === 'function') {
      theme.openDrawer(refs.panel, overlay, { returnFocus: refs.trigger, trapFocus: true });
    } else if (typeof theme.openModal === 'function') {
      theme.openModal(refs.panel, overlay);
    } else {
      refs.panel.classList.add('is-open');
      refs.panel.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
    }
    setExpanded(refs.trigger, true);
  }

  function closePopup(root) {
    var refs = parts(root);
    if (!refs || !refs.panel) return;
    var overlay = refs.overlay;
    var panel = refs.panel;
    var theme = api();
    if (root.dataset.productPopupStyle === 'drawer' && typeof theme.closeDrawer === 'function') {
      theme.closeDrawer(panel, overlay);
    } else if (typeof theme.closeModal === 'function') {
      theme.closeModal(panel, overlay);
    } else {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
    }
    panel.setAttribute('inert', '');
    if (overlay) overlay.classList.remove('overlay--product-popup-active');
    setExpanded(refs.trigger, false);
    if (refs.trigger && refs.trigger.isConnected) refs.trigger.focus({ preventScroll: true });
    window.setTimeout(function () {
      if (isOpen(panel)) return;
      panel.hidden = true;
      restorePanel(panel);
    }, 480);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var panel = document.querySelector('.product-popup__panel.is-open');
    var root = panel && panel._popupHome && panel._popupHome.root;
    if (root) closePopup(root);
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target && event.target.id === 'site-overlay' && event.target.classList.contains('overlay--product-popup-active')) {
      var openPanel = document.querySelector('.product-popup__panel.is-open');
      var homeRoot = openPanel && openPanel._popupHome && openPanel._popupHome.root;
      if (homeRoot) closePopup(homeRoot);
      return;
    }

    var closer = event.target.closest && event.target.closest('[data-product-popup-close]');
    if (closer) {
      var closeRoot = rootFrom(closer) || (closer.closest && closer.closest('.product-popup__panel') && closer.closest('.product-popup__panel')._popupHome && closer.closest('.product-popup__panel')._popupHome.root);
      if (closeRoot) closePopup(closeRoot);
      return;
    }

    var opener = event.target.closest && event.target.closest('[data-product-popup-open]');
    if (!opener) return;
    var root = rootFrom(opener);
    if (!root) {
      var panelId = opener.getAttribute('aria-controls');
      var targetPanel = panelId && document.getElementById(panelId);
      root = rootFrom(targetPanel) || (targetPanel && targetPanel._popupHome && targetPanel._popupHome.root);
      if (root) root._popupTrigger = opener;
    }
    var refs = parts(root);
    if (!refs) return;
    if (isOpen(refs.panel)) closePopup(root);
    else openPopup(root);
  });
})();
